import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { QuestionTableRedux } from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux";

const QuestionTableWrapper = ({ widgetProps, hotspotID, preview }) => {
  const component = { ...widgetProps, key: hotspotID, preview };

  return <QuestionTableRedux {...component} />;
};

QuestionTableWrapper.propTypes = {
  widgetProps: PropTypes.object.isRequired,
  hotspotID: PropTypes.string.isRequired,
  preview: PropTypes.bool,
  handleTableQuestion_Submit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  if (
    state.questionTable &&
    state.questionTable[ownProps.widgetProps.id] &&
    state.questionTable[ownProps.widgetProps.id].correct
  ) {
    ownProps.handleTableQuestion_Submit(ownProps.hotspotID);
  }

  return {
    ...ownProps,
  };
};

export default connect(mapStateToProps)(QuestionTableWrapper);
